import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupFisPointsCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/fis/points.hbs" })